import type { RefObject } from 'react'
import { PhotoMainToolbar } from '@/components/app/editor/tools/photo-main-toolbar'
import { resolvePlacedClikArtId } from '@/lib/clikart/sync-clikart-placement-from-shapes'
import {
  CLIKART_PHOTO_ACTION_DEFINITIONS,
  PHOTO_ACTION_DEFINITIONS,
} from '@/lib/photos/photo-action-items'
import { PhotoEffectsPopover } from '@/components/app/photos/photo-effects/photo-effects-popover'
import type { CenterCanvasConfig } from '../types/center-canvas-config'
import type { usePhotoActionBar } from '../hooks/use-photo-action-bar'

/**
 * The selected photo's floating action bar and its Photo Effects popover. Renders nothing unless
 * the action bar has a photo to show for.
 */
export function PhotoModeChrome({
  photoActionBar,
  scale,
  documentCanvasRef,
  photoEffectsOpen,
  onPhotoEffectsOpenChange,
}: {
  photoActionBar: ReturnType<typeof usePhotoActionBar>
  scale: number
  documentCanvasRef: RefObject<HTMLDivElement | null>
  photoEffectsOpen: boolean
  onPhotoEffectsOpenChange: CenterCanvasConfig['onPhotoEffectsOpenChange']
}) {
  const {
    selectedPhotoShapeForToolbar,
    photoToolbarRemovingBackground,
    isPhotoToolbarActionDisabled,
    photoToolbarHandlers,
    isPhotoToolbarActionActive,
    handlePhotoPezApplied,
  } = photoActionBar

  return (
    <>
      {selectedPhotoShapeForToolbar && (
        <PhotoMainToolbar
          shape={selectedPhotoShapeForToolbar}
          scale={scale}
          canvasRef={documentCanvasRef}
          handlers={photoToolbarHandlers}
          isDisabled={isPhotoToolbarActionDisabled}
          isActionActive={isPhotoToolbarActionActive}
          isRemovingBackground={photoToolbarRemovingBackground}
          actions={
            resolvePlacedClikArtId(selectedPhotoShapeForToolbar)
              ? CLIKART_PHOTO_ACTION_DEFINITIONS
              : PHOTO_ACTION_DEFINITIONS
          }
        />
      )}
      {selectedPhotoShapeForToolbar && (
        <PhotoEffectsPopover
          open={photoEffectsOpen}
          onOpenChange={(open) => onPhotoEffectsOpenChange?.(open)}
          shape={selectedPhotoShapeForToolbar}
          scale={scale}
          canvasRef={documentCanvasRef}
          onPezApplied={handlePhotoPezApplied}
        />
      )}
    </>
  )
}
